<div class="table-header">
  <div style="position: relative">
    <div
      id="map"
      [class.add-point-enabled]="addPointLocationsEnabled"
      (focus)="map.scrollWheelZoom.enable()"
      (focusout)="map.scrollWheelZoom.disable()"
      (keyup)="blurOnEscape($event)"
    ></div>
    <button class="pointToggleButton" (click)="toggleAllowingAddingLocations()">
      <picture>
        <source [srcset]="smallAddsrc" media="(max-width: 480px)" />
        <div
          class="add-location-container"
          [ngClass]="{ 'stop-adding': addPointLocationsEnabled }"
        >
          <img
            [src]="
              addPointLocationsEnabled
                ? '/assets/img/icons/map-markers/map-marker-pointer-white-active.png'
                : '/assets/img/icons/map-markers/map-marker-pointer-white.png'
            "
            alt="Location add button"
          />
          <span>{{
            !addPointLocationsEnabled ? "Drop Pin" : "Stop Adding"
          }}</span>
        </div>
      </picture>
    </button>
    <div class="short-help" *ngIf="showShortHelp">
      <h3 class="short-title">
        Drop a pin and add details in the Location table!
      </h3>
      <p class="short-description">
        <strong>...or skip the map</strong> and add locations directly in the
        table below.
      </p>
      <button class="question-mark" (click)="toggleLongHelp()">?</button>
    </div>

    <div class="long-help" *ngIf="showLongHelp">
      <div class="title-row">
        <h3 class="long-title">Map Info</h3>
        <button class="close-button" (click)="toggleLongHelp()">X</button>
      </div>
      <div class="help-content">
        <p class="section-title">Dropping a pin on the map</p>
        <ol class="long-description-list">
          <li>Select <strong>Drop Pin</strong> to activate pin drop cursor.</li>
          <li>
            Use the zoom buttons, mouse scroll, and/or click-and-drag to locate
            an area on the map.
          </li>
          <li>Click once on the map to drop a pin.</li>
          <li>
            Fill out <strong>Location Name</strong> (required) in the Location
            table to activate <strong>Save</strong> button.
          </li>
          <li>
            Pin drop icons are assigned to locations with a latitude and
            longitude. Multiple locations can be rearranged in the Location
            table below.
          </li>
        </ol>
        <p class="section-title">View pin drop details on the map</p>
        <ul>
          <li>
            Select a pin drop icon to view a pop-up with its location name,
            latitude, and longitude.
          </li>
        </ul>
        <p class="section-title">Edit a location</p>
        <ul>
          <li>
            Double-click text in the field to edit. Click out of the field, tab,
            or press enter to save the change.
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div style="display: none">
    <a
      *ngFor="let location of locations"
      href="javascript:void(0);"
      (click)="logImOk($event, location)"
      class="imOkBridgeHref-{{ location.locationId }}"
      >im ok at {{ location.description }}</a
    >
  </div>
</div>
<div class="loading-panel" *ngIf="!trip"></div>
